import { setValueInLocalStorage } from '@jpi-cloud-web-pro/jpi-cloud-shared/services/storage';
import { getFromLocalStorageByKey, removeFromLocalStorage, saveToLocalStorage } from '.';
import { removeLocalStorageDeviceMenuKeys } from './lastUsedDeviceMenu';

const LAST_USED_SYSTEM = 'LAST_USED_SYSTEM';

export const setLastUsedSystemId = systemId => {
  const lastUsedSystem = getLastUsedSystemId();
  if (systemId !== lastUsedSystem) {
    removeLocalStorageDeviceMenuKeys();
  }
  saveToLocalStorage(LAST_USED_SYSTEM, systemId);
  setValueInLocalStorage('SELECTED_DEVICE_ID', systemId);
};

export const getLastUsedSystemId = () => getFromLocalStorageByKey(LAST_USED_SYSTEM);

export const removeLastUsedSystemId = () => removeFromLocalStorage(LAST_USED_SYSTEM);
